/* Dutch'D reviews drawer — reads Judge.me review data, renders it in our own design */
(function () {
  'use strict';
  if (window.__ddReviews) return;
  window.__ddReviews = true;

  var PER_PAGE = 5;
  var STAR = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(n, size) {
    var out = '<span class="ddr-stars" style="--ddr-star:' + (size || 12) + 'px" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) out += '<svg viewBox="0 0 24 24"><path class="' + (i <= Math.round(n) ? 'ddr-s-on' : 'ddr-s-off') + '" d="' + STAR + '"/></svg>';
    return out + '</span>';
  }

  /* ---------- Fit: map a Judge.me custom answer to 0 (klein) … 1 (groot) ---------- */
  var FIT_Q = /pasvorm|valt de maat|hoe valt|fit|passform|f(ä|ae)llt/i;
  var BOUGHT_Q = /gekocht|bought|gekauft|normale maat|usual size|normale gr/i;
  function fitValue(ans) {
    if (ans == null) return null;
    var a = String(ans).toLowerCase().trim();
    var num = parseFloat(a);
    if (!isNaN(num) && /^\d/.test(a) && num >= 1 && num <= 5) { // scale answers like "1".."5"
      return Math.max(0, Math.min(1, (num - 1) / 4));
    }
    if (/(veel|much|viel).*(klein|small)/.test(a)) return 0;
    if (/(iets|bit|etwas).*(klein|small)/.test(a)) return 0.25;
    if (/klein|small/.test(a)) return 0.15;
    if (/(veel|much|viel).*(groot|large|big|gro)/.test(a)) return 1;
    if (/(iets|bit|etwas).*(groot|large|big|gro)/.test(a)) return 0.75;
    if (/groot|large|big|gro(ß|ss)/.test(a)) return 0.85;
    if (/normaal|normal|true|klopt|passt/.test(a)) return 0.5;
    return null;
  }

  /* ---------- Adapter: Judge.me widget HTML → plain review objects ---------- */
  function parseJudgeMe(html) {
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    function txt(sel, el) { var n = $(sel, el); return n ? n.textContent.trim() : ''; }
    function attr(sel, el, a) { var n = $(sel, el); return n ? n.getAttribute(a) : null; }
    var revs = $$('.jdgm-rev', doc).map(function (el) {
      var score = parseFloat(attr('.jdgm-rev__rating', el, 'data-score') || el.getAttribute('data-score')) || 0;
      var ts = $('.jdgm-rev__timestamp', el);
      var custom = $$('.jdgm-rev__cf-ans', el).map(function (c) {
        return { q: ($('.jdgm-rev__cf-ans__title', c) || c).textContent.replace(/:\s*$/, '').trim(), a: ($('.jdgm-rev__cf-ans__value', c) || c).textContent.trim() };
      });
      var pics = $$('.jdgm-rev__pics img, .jdgm-rev__pic-img', el).map(function (img) {
        var s = img.getAttribute('data-src') || img.getAttribute('src') || '';
        var big = (img.closest('a') && img.closest('a').getAttribute('href')) || s;
        return { thumb: s, full: big };
      }).filter(function (p) { return p.thumb; });
      var reply = $('.jdgm-rev__reply-content, .jdgm-rev__reply .jdgm-rev__body', el);
      return {
        id: el.getAttribute('data-review-id'),
        score: score,
        name: txt('.jdgm-rev__author', el),
        verified: el.getAttribute('data-verified-buyer') === 'true' || !!$('.jdgm-rev__buyer-badge', el),
        date: ts ? (ts.getAttribute('data-content') || ts.textContent || '').trim() : '',
        title: txt('.jdgm-rev__title', el),
        body: txt('.jdgm-rev__body', el),
        custom: custom,
        pics: pics,
        reply: reply ? reply.textContent.trim() : '',
        translated: !!$('.jdgm-rev__translated, [data-translated="true"]', el)
      };
    });
    var hist = {};
    $$('.jdgm-histogram__row', doc).forEach(function (r) {
      hist[r.getAttribute('data-rating')] = parseInt(r.getAttribute('data-frequency'), 10) || 0;
    });
    var total = parseInt(attr('.jdgm-rev-widg', doc, 'data-number-of-reviews'), 10);
    return { reviews: revs, hist: hist, total: isNaN(total) ? null : total };
  }

  /* ---------- Adapter: Judge.me v3 JSON → the same review objects ---------- */
  function pick(o, keys) {
    for (var i = 0; i < keys.length; i++) {
      var path = keys[i].split('.'), v = o;
      for (var j = 0; j < path.length && v != null; j++) v = v[path[j]];
      if (v != null && v !== '') return v;
    }
    return null;
  }
  function stripHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.innerHTML = String(s).replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p>/gi, '\n\n');
    return d.textContent.trim();
  }
  function fmtDate(s) {
    if (!s) return '';
    var d = new Date(s);
    if (isNaN(d)) return String(s);
    var lang = (document.documentElement.lang || 'nl').slice(0, 2);
    try { return d.toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return d.toISOString().slice(0, 10); }
  }
  function parseJudgeMeJson(data) {
    /* Multi-language stores split reviews into primary/other language lists; plain stores use "reviews" */
    var seen = {}, list = [].concat(data.primary_language_reviews || [], data.other_language_reviews || [], data.reviews || [])
      .filter(function (r) { var k = r.uuid || r.id; if (!k) return true; if (seen[k]) return false; seen[k] = 1; return true; });
    var revs = list.map(function (r) {
      var pics = (pick(r, ['pictures_urls', 'pictures', 'photos', 'media', 'images']) || []).map(function (p) {
        if (typeof p === 'string') return { thumb: p, full: p };
        var full = pick(p, ['urls.huge', 'urls.original', 'huge', 'original', 'url', 'src', 'original_url']);
        var thumb = pick(p, ['urls.compact', 'urls.small', 'compact', 'small', 'thumbnail_url', 'thumb', 'url', 'src']) || full;
        return { thumb: thumb, full: full || thumb };
      }).filter(function (p) { return p.thumb; });
      var custom = (pick(r, ['cf_answers', 'custom_form_answers', 'custom_forms', 'custom_form']) || []).map(function (c) {
        var a = pick(c, ['value', 'answer', 'values']);
        if (Array.isArray(a)) a = a.join(', ');
        return { q: String(pick(c, ['question_title', 'title', 'question', 'label', 'name']) || ''), a: String(a == null ? '' : a) };
      });
      return {
        id: String(pick(r, ['uuid', 'id', 'review_id']) || ''),
        score: parseFloat(pick(r, ['rating', 'score'])) || 0,
        name: String(pick(r, ['reviewer_name', 'reviewer.name', 'author', 'name']) || ''),
        verified: !!pick(r, ['verified_buyer', 'is_verified_buyer', 'verified']) || pick(r, ['verified']) === 'buyer',
        date: fmtDate(pick(r, ['created_at', 'published_at', 'date'])),
        title: String(pick(r, ['title']) || ''),
        body: stripHtml(pick(r, ['body', 'body_html', 'content'])),
        custom: custom,
        pics: pics,
        reply: stripHtml(pick(r, ['reply_content', 'reply.content', 'reply.body', 'reply'])),
        product: String(pick(r, ['product_title_localized', 'product_title']) || ''),
        translated: !!pick(r, ['translated', 'is_translated'])
      };
    });
    var hist = {};
    (data.histogram || []).forEach(function (h) { hist[h.rating] = h.frequency || 0; });
    var pg = data.primary_language_pagination || data.pagination || {}, pg2 = data.other_language_pagination || {};
    var pages = pg.total_pages == null ? null : Math.max(pg.total_pages || 0, pg2.total_pages || 0);
    return { reviews: revs, hist: hist, total: data.number_of_reviews == null ? null : data.number_of_reviews, pages: pages, perPage: pg.per_page };
  }

  /* ---------- Drawer ---------- */
  function Drawer(root) {
    this.root = root;
    this.cfg = JSON.parse(($('script[data-ddr-config]', root) || {}).textContent || '{}');
    this.t = this.cfg.t || {};
    this.list = $('[data-ddr-list]', root);
    this.panel = $('.ddr-drawer__panel', root);
    this.reviews = [];
    this.page = 0;
    this.perPage = PER_PAGE;
    this.done = !this.cfg.count;
    this.filter = { star: null, photos: false, size: false };
    this.sort = 'recent';
    this.bind();
  }

  Drawer.prototype.bind = function () {
    var self = this;
    $$('[data-ddr-open]').forEach(function (b) {
      if (b.getAttribute('data-ddr-open') !== String(self.cfg.productId)) return;
      b.addEventListener('click', function (e) { e.preventDefault(); self.open(b); });
    });
    $$('[data-ddr-close]', this.root).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if ($('.ddr-lightbox.is-open')) return self.closeLightbox(); self.close(); }
      if (e.key === 'Tab') self.trap(e);
    });
    $$('[data-ddr-star]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ddr-star');
        self.filter.star = self.filter.star === v ? null : v;
        $$('[data-ddr-star]', self.root).forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-ddr-star') === self.filter.star)); });
        self.ensureAll(function () { self.render(); });
      });
    });
    $$('[data-ddr-chip]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-ddr-chip');
        if (k === 'all') { self.filter = { star: null, photos: false, size: false }; $$('[data-ddr-star]', self.root).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); }
        else self.filter[k] = !self.filter[k];
        self.syncChips();
        self.ensureAll(function () { self.render(); });
      });
    });
    var sel = $('[data-ddr-sort]', this.root);
    if (sel) sel.addEventListener('change', function () { self.sort = sel.value; self.ensureAll(function () { self.render(); }); });
    var more = $('[data-ddr-more]', this.root);
    if (more) more.addEventListener('click', function () { self.load(); });
    var write = $('[data-ddr-write]', this.root);
    if (write) write.addEventListener('click', function () { self.write(); });
    var how = $('[data-ddr-how]', this.root);
    if (how) how.addEventListener('click', function () {
      var p = $('[data-ddr-how-text]', self.root);
      p.hidden = !p.hidden;
      how.setAttribute('aria-expanded', String(!p.hidden));
    });
    this.root.addEventListener('click', function (e) {
      var pic = e.target.closest('[data-ddr-pic]');
      if (pic) self.lightbox(pic.getAttribute('data-ddr-pic'));
    });
    var lbClose = $('.ddr-lightbox [data-ddr-lb-close]', this.root);
    if (lbClose) lbClose.addEventListener('click', function () { self.closeLightbox(); });
    if (location.hash === '#reviews') this.open();
  };

  Drawer.prototype.syncChips = function () {
    var f = this.filter;
    $$('[data-ddr-chip]', this.root).forEach(function (b) {
      var k = b.getAttribute('data-ddr-chip');
      b.setAttribute('aria-pressed', String(k === 'all' ? (!f.photos && !f.size && !f.star) : !!f[k]));
    });
  };

  Drawer.prototype.open = function (opener) {
    this.opener = opener || document.activeElement;
    this.root.hidden = false;
    var self = this;
    requestAnimationFrame(function () {
      self.root.classList.add('is-open');
      document.documentElement.classList.add('ddr-lock');
      self.root.setAttribute('aria-hidden', 'false');
      var c = $('.ddr-close', self.root);
      if (c) c.focus();
    });
    if (!this.page) this.load();
  };

  Drawer.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ddr-lock');
    if (this.opener && this.opener.focus) this.opener.focus();
  };

  Drawer.prototype.trap = function (e) {
    var f = $$('button:not([disabled]), [href], select, input, textarea, [tabindex]:not([tabindex="-1"])', this.panel).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Drawer.prototype.url = function (page) {
    var c = this.cfg;
    return 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(c.shop) +
      '&shop_domain=' + encodeURIComponent(c.shop) + '&platform=shopify&page=' + page +
      '&per_page=' + this.perPage + '&product_id=' + c.productId;
  };

  Drawer.prototype.load = function (cb) {
    var self = this;
    if (this.loading || this.done) { if (cb) cb(); return; }
    this.loading = true;
    var next = this.page + 1;
    var useInline = next === 1 && this.cfg.inlineJson;
    var p = useInline ? Promise.resolve(this.cfg.inlineJson) :
      fetch(this.url(next), { credentials: 'omit' }).then(function (r) { return r.json(); });
    p.then(function (data) {
      var isJson = data.reviews || data.primary_language_reviews || data.other_language_reviews;
      var parsed = isJson ? parseJudgeMeJson(data) : parseJudgeMe(data.html || '');
      var known = {};
      self.reviews.forEach(function (r) { known[r.id] = true; });
      parsed.reviews.forEach(function (r) { if (!r.id || !known[r.id]) self.reviews.push(r); });
      if (next === 1) { self.renderHist(parsed.hist); if (parsed.perPage) self.perPage = parsed.perPage; }
      self.page = next;
      if (parsed.pages != null ? next >= parsed.pages : parsed.reviews.length < self.perPage) self.done = true;
      if (self.reviews.length >= self.cfg.count) self.done = true;
      self.loading = false;
      self.render();
      if (cb) cb();
    }).catch(function () {
      self.loading = false;
      self.done = true;
      if (!self.reviews.length) self.list.innerHTML = '<p class="ddr-empty">' + esc(self.t.error) + '</p>';
      if (cb) cb();
    });
  };

  Drawer.prototype.ensureAll = function (cb) {
    var self = this;
    var active = this.filter.star || this.filter.photos || this.filter.size || this.sort !== 'recent';
    if (!active || this.done) return cb();
    (function step() { if (self.done) return cb(); self.load(step); })();
  };

  Drawer.prototype.fitOf = function (r) {
    for (var i = 0; i < r.custom.length; i++) if (FIT_Q.test(r.custom[i].q) && !BOUGHT_Q.test(r.custom[i].q)) {
      var v = fitValue(r.custom[i].a);
      if (v !== null) return { v: v, label: r.custom[i].a };
    }
    return null;
  };

  Drawer.prototype.sizeOf = function (r) {
    for (var i = 0; i < r.custom.length; i++) if (/gekocht|bought|gekauft/i.test(r.custom[i].q) && /\d/.test(r.custom[i].a)) return r.custom[i].a.trim();
    return '';
  };

  Drawer.prototype.renderHist = function (hist) {
    var total = 0, k;
    for (k in hist) total += hist[k];
    if (!total) { // no histogram in the data: count from the loaded reviews
      hist = {};
      this.reviews.forEach(function (r) { var s = Math.round(r.score); hist[s] = (hist[s] || 0) + 1; total++; });
    }
    for (var s = 1; s <= 5; s++) {
      var n = hist[s] || 0;
      var bar = $('[data-ddr-bar="' + s + '"]', this.root), cnt = $('[data-ddr-n="' + s + '"]', this.root), btn = $('[data-ddr-star="' + s + '"]', this.root);
      if (bar) bar.style.width = (total ? Math.round(n / total * 100) : 0) + '%';
      if (cnt) cnt.textContent = n;
      if (btn) btn.disabled = !n;
    }
  };

  Drawer.prototype.currentSize = function () {
    var input = $('form[action*="/cart/add"] [name="id"]');
    var id = input ? String(input.value) : '';
    return (this.cfg.variants || {})[id] || '';
  };

  Drawer.prototype.render = function () {
    var self = this, t = this.t, f = this.filter, selSize = this.currentSize();
    var rows = this.reviews.filter(function (r) {
      if (f.star && String(Math.round(r.score)) !== f.star) return false;
      if (f.photos && !r.pics.length) return false;
      if (f.size && selSize && self.sizeOf(r) !== String(selSize)) return false;
      return true;
    });
    if (this.sort === 'high') rows.sort(function (a, b) { return b.score - a.score; });
    if (this.sort === 'low') rows.sort(function (a, b) { return a.score - b.score; });
    if (this.sort === 'photos') rows.sort(function (a, b) { return b.pics.length - a.pics.length; });

    if (!rows.length) {
      this.list.innerHTML = '<p class="ddr-empty">' + esc(this.reviews.length ? t.noMatch : t.none) + '</p>';
    } else {
      this.list.innerHTML = rows.map(function (r) {
        var fit = self.fitOf(r), size = self.sizeOf(r), meta = [];
        if (r.product && self.cfg.productTitle && r.product.toLowerCase() !== String(self.cfg.productTitle).toLowerCase()) meta.push(esc(t.bought) + ': <strong>' + esc(r.product) + '</strong>');
        if (size) meta.push(esc(t.size) + ': <strong>' + esc(size) + '</strong>');
        if (fit) meta.push(esc(t.fit) + ': <strong>' + esc(fit.label) + '</strong>');
        if (r.translated) meta.push(esc(t.translated));
        var pics = r.pics.length ? '<div class="ddr-rev__pics">' + r.pics.map(function (p) {
          return '<button type="button" data-ddr-pic="' + esc(p.full) + '" aria-label="' + esc(t.photo) + '"><img src="' + esc(p.thumb) + '" alt="" loading="lazy" width="64" height="64"></button>';
        }).join('') + '</div>' : '';
        return '<article class="ddr-rev">' +
          '<div class="ddr-rev__top"><div class="ddr-rev__who"><span class="ddr-rev__name">' + esc(r.name) + '</span>' +
          (r.verified ? '<span class="ddr-rev__ver">' + CHECK + esc(t.verified) + '</span>' : '') + '</div>' +
          '<span class="ddr-rev__date">' + esc(r.date) + '</span></div>' +
          '<div class="ddr-rev__head">' + stars(r.score, 12) + '<span class="visually-hidden">' + esc(r.score) + '/5</span>' +
          (r.title ? '<h3 class="ddr-rev__title">' + esc(r.title) + '</h3>' : '') + '</div>' +
          (r.body ? '<p class="ddr-rev__text">' + esc(r.body) + '</p>' : '') + pics +
          (meta.length ? '<div class="ddr-rev__meta"><span>' + meta.join('</span><span>') + '</span></div>' : '') +
          (r.reply ? '<div class="ddr-rev__reply"><strong>' + esc(t.reply) + '</strong>' + esc(r.reply) + '</div>' : '') +
          '</article>';
      }).join('');
    }
    var more = $('[data-ddr-more]', this.root);
    if (more) more.hidden = this.done || !!(f.star || f.photos || f.size);

    this.renderFit();
    this.renderPhotos();
  };

  Drawer.prototype.renderFit = function () {
    var box = $('[data-ddr-fit]', this.root);
    if (!box) return;
    var vals = [], self = this;
    this.reviews.forEach(function (r) { var f = self.fitOf(r); if (f) vals.push(f.v); });
    if (vals.length < 3) { box.hidden = true; return; }
    var avg = vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    var label = avg < 0.38 ? this.t.fitSmall : (avg > 0.62 ? this.t.fitLarge : this.t.fitNormal);
    $('[data-ddr-fit-dot]', box).style.left = (avg * 100).toFixed(1) + '%';
    $('[data-ddr-fit-label]', box).textContent = this.t.fitMost + ' ' + label.toLowerCase();
    $('[data-ddr-fit-track]', box).setAttribute('aria-valuenow', Math.round(avg * 100));
    box.hidden = false;
    var line = $('[data-ddr-line-fit="' + this.cfg.productId + '"]');
    if (line) { line.textContent = label; line.hidden = false; var s = line.previousElementSibling; if (s) s.hidden = false; }
  };

  Drawer.prototype.renderPhotos = function () {
    var box = $('[data-ddr-photos]', this.root);
    if (!box) return;
    var all = [];
    this.reviews.forEach(function (r) { all = all.concat(r.pics); });
    if (!all.length) { box.hidden = true; return; }
    var max = window.matchMedia('(max-width: 767px)').matches ? 4 : 5;
    var shown = all.slice(0, max), extra = all.length - shown.length;
    $('.ddr-photos__grid', box).innerHTML = shown.map(function (p, i) {
      var last = i === shown.length - 1 && extra > 0;
      return '<button type="button" data-ddr-pic="' + esc(p.full) + '" aria-label="' + esc(this.t.photo) + '"><img src="' + esc(p.thumb) + '" alt="" loading="lazy">' +
        (last ? '<span class="ddr-photos__more">+' + extra + '</span>' : '') + '</button>';
    }, this).join('');
    box.hidden = false;
  };

  Drawer.prototype.lightbox = function (src) {
    var lb = $('.ddr-lightbox', this.root);
    $('img', lb).src = src;
    lb.classList.add('is-open');
    $('[data-ddr-lb-close]', lb).focus();
  };
  Drawer.prototype.closeLightbox = function () {
    var lb = $('.ddr-lightbox', this.root);
    lb.classList.remove('is-open');
    $('img', lb).removeAttribute('src');
  };

  /* "Schrijf een review": opens Judge.me's own form (stars, text, photos, spam checks, verification) */
  Drawer.prototype.write = function () {
    var host = $('.ddr-jdgm-host') || document;
    var btn = $('.jm-action-buttons__button, .jdgm-write-rev-link, .jdgm-rev-widg__write-rev-link, [data-jdgm-write-review]', host);
    if (!btn) return;
    this.close();
    btn.click();
  };

  function init() {
    $$('[data-ddr-drawer]').forEach(function (root) {
      if (root.__ddr) return;
      document.body.appendChild(root); // escape any overflow/transform of the product column
      root.__ddr = new Drawer(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);

  /* Warm the fit label under the price without opening the drawer */
  window.addEventListener('load', function () {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(function () {
      $$('[data-ddr-drawer]').forEach(function (root) {
        var d = root.__ddr;
        if (d && d.cfg.count >= 3 && !d.page) d.load();
      });
    });
  });
})();
